import { render, staticRenderFns } from "./research.vue?vue&type=template&id=25b17da0&scoped=true&"
import script from "./research.vue?vue&type=script&lang=ts&"
export * from "./research.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b17da0",
  null
  
)

export default component.exports